// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.withdraw-title {
  font-family: Roboto;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #000000;
}
.custom-withdraw-button {
  opacity: 1;
  gap: 8px;
  border-radius: 5px;
  padding-top: 11px;
  padding-right: 16px;
  padding-bottom: 11px;
  padding-left: 16px;
  animation-timing-function: ease-out;
  animation-duration: 300ms;
  background: #f0f0f0;
  height: 40px;
}
.custom-withdraw-button:hover {
  background: #f0f0f0 !important;
}
.custom-withdraw-button.ant-btn-variant-solid:not(:disabled):not(
    .ant-btn-disabled
  ):active {
  background: #f0f0f0 !important;
  color: #0a0f0d !important;
}
.once-withdraw-paragraph {
  top: 64px;
  left: 24px;
  opacity: 1;
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
}
.withdraw-request-text {
  font-family: Roboto;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: var(--Colors-Text-500, #0a0f0d);
}
.keep-wait-button {
  height: 40px;
  opacity: 1;
  gap: 8px;
  border-radius: 5px;
  padding-top: 11px;
  padding-right: 16px;
  padding-bottom: 11px;
  padding-left: 16px;
  background: var(--Colors-Primary-500, #d2042d);
}
.keep-wait-button:hover {
  background-color: #d2042d !important;
}
.keep-wait-button-text {
  font-family: Roboto;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #ffffff;
}
.products-not-reserved-row {
  top: 129px;
  left: 24px;
  opacity: 1;
  gap: 8px;
  border-radius: 5px;
  padding-top: 8px;
  padding-right: 12px;
  padding-bottom: 8px;
  padding-left: 12px;
  background: #ffe6eb;
  margin-top: 20px;
  margin-bottom: 20px;
}
.products-not-reserved-text {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 19.5px;
  letter-spacing: 0%;
  color: var(--Colors-Primary-500, #d2042d);
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/checkout-page-modal/CustomTermsModal.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,8BAA8B;AAChC;AACA;;;EAGE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,8CAA8C;AAChD;AACA;EACE,oCAAoC;AACtC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,UAAU;EACV,UAAU;EACV,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C","sourcesContent":[".withdraw-title {\n  font-family: Roboto;\n  font-weight: 600;\n  font-style: SemiBold;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: #000000;\n}\n.custom-withdraw-button {\n  opacity: 1;\n  gap: 8px;\n  border-radius: 5px;\n  padding-top: 11px;\n  padding-right: 16px;\n  padding-bottom: 11px;\n  padding-left: 16px;\n  animation-timing-function: ease-out;\n  animation-duration: 300ms;\n  background: #f0f0f0;\n  height: 40px;\n}\n.custom-withdraw-button:hover {\n  background: #f0f0f0 !important;\n}\n.custom-withdraw-button.ant-btn-variant-solid:not(:disabled):not(\n    .ant-btn-disabled\n  ):active {\n  background: #f0f0f0 !important;\n  color: #0a0f0d !important;\n}\n.once-withdraw-paragraph {\n  top: 64px;\n  left: 24px;\n  opacity: 1;\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n}\n.withdraw-request-text {\n  font-family: Roboto;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-500, #0a0f0d);\n}\n.keep-wait-button {\n  height: 40px;\n  opacity: 1;\n  gap: 8px;\n  border-radius: 5px;\n  padding-top: 11px;\n  padding-right: 16px;\n  padding-bottom: 11px;\n  padding-left: 16px;\n  background: var(--Colors-Primary-500, #d2042d);\n}\n.keep-wait-button:hover {\n  background-color: #d2042d !important;\n}\n.keep-wait-button-text {\n  font-family: Roboto;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: #ffffff;\n}\n.products-not-reserved-row {\n  top: 129px;\n  left: 24px;\n  opacity: 1;\n  gap: 8px;\n  border-radius: 5px;\n  padding-top: 8px;\n  padding-right: 12px;\n  padding-bottom: 8px;\n  padding-left: 12px;\n  background: #ffe6eb;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.products-not-reserved-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px;\n  line-height: 19.5px;\n  letter-spacing: 0%;\n  color: var(--Colors-Primary-500, #d2042d);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
